module.exports = __webpack_public_path__ + "static/media/NFLPA-Chicago-Logo.a9114586.png";